'use client'

import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@wartek-id/tabs'

import { TrackerSection, TrackerSubSection } from '@/utils/tracker/shared'

import { HeadingTitleBlock } from '@/components/HeadingTitleBlock/HeadingTitleBlock'
import { DataIndukIcon } from '@/components/Icons/DataIndukIcon'

import { METATAG } from '@/configs/constants'

import { DiktiPanel } from './components/TabNasional/DiktiPanel'
import { PaudDikdasmenPanel } from './components/TabNasional/PaudDikdasmenPanel'

export const DataIndukNasional = () => {
  return (
    <>
      <HeadingTitleBlock
        withIcon={true}
        withFaqText={true}
        withMapOverlay={true}
        icon={<DataIndukIcon />}
        title={METATAG.DATA_INDUK_SATPEN.title}
        desc={METATAG.DATA_INDUK_SATPEN.description}
        trackerGaEventName="induk"
        trackerPageTitle="Data Induk"
        trackerAdditionalParams={{
          section: TrackerSection.SATPEN,
          sub_section: TrackerSubSection.PAUD_DIKDASMEN,
        }}
      />
      <article>
        <section id="tab-section">
          <Tabs defaultIndex={0} isFitted>
            <TabList className="container mx-auto">
              <Tab data-testid="tab-pauddikdasmen">PAUD DIKDASMEN</Tab>
              <Tab data-testid="tab-dikti">DIKTI</Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <PaudDikdasmenPanel />
              </TabPanel>
              <TabPanel>
                <DiktiPanel />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </section>
      </article>
    </>
  )
}
